import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import {getSeatUsageText} from './helpers';

type Props = {
    isPurchased: boolean;
    isUnlimited: boolean;
    numUsed: number;
    numBought: number;
    purchaseLink?: string | null;
    maxSeatsReached: boolean;
    displayName: string;
};

export function SwitchText(props: Props) {
    const {
        isPurchased,
        isUnlimited,
        numUsed,
        numBought,
        purchaseLink,
        maxSeatsReached,
        displayName,
    } = props;

    return (
        <div>
            {isPurchased || isUnlimited ? (
                <>
                    <Body color='light'>{getSeatUsageText(numUsed, numBought)}</Body>
                    {maxSeatsReached && purchaseLink && (
                        // @ts-expect-error
                        <Link as={RoutedLink} variant='primary' to={purchaseLink} size='normal'>
                            {' '}
                            Purchase more
                        </Link>
                    )}
                </>
            ) : (
                <>
                    <Body color='light'>
                        You haven’t enabled {displayName}.{' '}
                        {purchaseLink && (
                            // @ts-expect-error
                            <Link as={RoutedLink} variant='primary' to={purchaseLink} size='normal'>
                                Upgrade your plan
                            </Link>
                        )}
                    </Body>
                </>
            )}
        </div>
    );
}
